import { render, staticRenderFns } from "./POIManagerEdit.vue?vue&type=template&id=8d228b2e&scoped=true"
import script from "./POIManagerEdit.vue?vue&type=script&lang=js"
export * from "./POIManagerEdit.vue?vue&type=script&lang=js"
import style0 from "./POIManagerEdit.vue?vue&type=style&index=0&id=8d228b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d228b2e",
  null
  
)

export default component.exports